import { useEffect, useState } from 'react';

export function useChartData(fetchFn: () => Promise<any>) {
	const [data, setData] = useState<any[]>([]);
	const [loading, setLoading] = useState(true);
	const colors = ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#F44336', '#00BCD4'];

	useEffect(() => {
		const load = async () => {
			setLoading(true);
			try {
				const resp = await fetchFn();
				if (resp.status === 200) {
					const transformed = resp.data.map((item: any, index: number) => ({
						label: item.label,
						value: Number(item.value),
						color: colors[index % colors.length],
					}));
					setData(transformed);
				}
			} finally {
				setLoading(false);
			}
		};
		load();
	}, [fetchFn]);

	return { data, loading };
}
